

// import { Pie } from "react-chartjs-2";
// import { BsGraphUpArrow } from "react-icons/bs";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend
// } from "chart.js";
// import { useTranslation } from "react-i18next";

// ChartJS.register(ArcElement, Tooltip, Legend);

// export default function MyPieChart({ dataSource = [], title }) {
//   console.log("check data in stock",dataSource)
//   const { t } = useTranslation();

//   // 🔹 Group data by ledger_id
//   const groupedLedgerData = () => {
//     const map = {};

//     dataSource.forEach(item => {
//       const ledgerId = item.ledger_id;

//       const stock =
//         Number(item.opening_stock || 0) +
//         Number(item.in_side || 0) -
//         Number(item.out_side || 0);

//       if (!map[ledgerId]) {
//         map[ledgerId] = {
//           name: item.ledger_name,
//           totalQuantity: 0
//         };
//       }

//       map[ledgerId].totalQuantity += stock;
//     });

//     // ❗ Pie chart does NOT support negative / zero
//     return Object.values(map).filter(
//       item => item.totalQuantity > 0
//     );
//   };

//   const finalData = groupedLedgerData();

//   // 🔹 No data UI
//   if (!finalData.length) {
//     return (
//       <div className="py-5 text-center text-muted">
//         <div className="flex justify-center py-3">
//           <div className="rounded-full border p-4">
//             <BsGraphUpArrow className="text-[50px] text-red-400" />
//           </div>
//         </div>
//         {t("noDataAvailable")}
//       </div>
//     );
//   }

//   // 🔹 Chart data
//   const chartData = {
//     labels: finalData.map(i => i.name),
//     datasets: [
//       {
//         data: finalData.map(i => i.totalQuantity),
//         backgroundColor: [
//           'rgba(240, 115, 115, 0.8)',
//         'rgba(91, 240, 171, 0.8)',
//         'rgba(84, 146, 222, 0.8)',
//         'rgba(209, 170, 73, 0.8)',
//         'rgba(180, 76, 212, 0.8)',
//         'rgba(168, 219, 83, 0.8)',

//         ],
//              borderColor: [
//         'rgba(240, 115, 115, 1)',
//            'rgba(91, 240, 171, 1)',  
       
//           'rgba(84, 146, 222, 1)',
//           'rgba(209, 170, 73, 1)',
//         'rgba(180, 76, 212, 1)',
//          'rgba(168, 219, 83, 1)',
//       ],
//         borderWidth: 1,
//          borderWidth: 2,
//         hoverOffset: 6
//       }
//     ]
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//       layout: {
//     padding: {
//       top: 1,
//       bottom: 1,
//       left: 1,
//       right: 1
//     }
//   },
//     plugins: {
//       legend: { position: "top" },
//       title: {
//         display: !!title,
//         text: title
//       },
//       tooltip: {
//           cornerRadius: 8,
//           padding: 14,
//           boxPadding: 8,
//         callbacks: {
//           label: ctx =>
//             `${ctx.label}: ${ctx.formattedValue}`
//         }
//       }
//     }
//   };

//   return <Pie data={chartData} options={options} />;
// }


import { Pie } from "react-chartjs-2";
import { BsGraphUpArrow } from "react-icons/bs";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import { useTranslation } from "react-i18next";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function MyPieChart({ dataSource = [], title }) {
  const { t } = useTranslation();

  const groupedLedgerData = () => {
    const map = {};

    dataSource.forEach(item => {
      const key = `${item.ledger_id}_${item.branch_id}`;

      const stock =
        Number(item.opening_stock || 0) +
        Number(item.in_side || 0) -
        Number(item.out_side || 0);

      if (!map[key]) {
        map[key] = {
          name: item.ledger_name,
          branchName: item.branch_name,
          positive: 0,
          negative: 0,
        };
      }

      if (stock >= 0) map[key].positive += stock;
      else map[key].negative += Math.abs(stock);
    });

    const result = [];

    Object.values(map).forEach(item => {
      if (item.positive > 0)
        result.push({
          name: item.name,
          branchName: item.branchName,
          value: item.positive
        });

      if (item.negative > 0)
        result.push({
          name: `${item.name} (${t("outOfStock")})`,
          branchName: item.branchName,
          value: item.negative
        });
    });

    return result;
  };

  const finalData = groupedLedgerData();

  if (!finalData.length) {
    return (
      <div className="py-5 text-center text-muted">
        <div className="flex justify-center py-3">
          <div className="rounded-full border p-4">
            <BsGraphUpArrow className="text-[50px] text-red-400" />
          </div>
        </div>
        {t("noDataAvailable")}
      </div>
    );
  }

  const chartData = {
    labels: finalData.map(i => i.name),
    datasets: [
      {
        data: finalData.map(i => i.value),
        backgroundColor: [
          'rgba(240,115,115,0.8)',
          'rgba(91,240,171,0.8)',
          'rgba(84,146,222,0.8)',
          'rgba(209,170,73,0.8)',
          'rgba(180,76,212,0.8)',
          'rgba(168,219,83,0.8)',
        ],
        borderColor: [
          'rgba(240,115,115,1)',
          'rgba(91,240,171,1)',
          'rgba(84,146,222,1)',
          'rgba(209,170,73,1)',
          'rgba(180,76,212,1)',
          'rgba(168,219,83,1)',
        ],
        borderWidth: 2,
        hoverOffset: 6
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      title: { display: !!title, text: title },
      tooltip: {
        callbacks: {
          label: function (ctx) {
            const item = finalData[ctx.dataIndex];
            return `${item.name} - ${item.branchName}: ${ctx.formattedValue}`;
          }
        }
      }
    }
  };

  return <Pie data={chartData} options={options} />;
}